export default __webpack_public_path__ + "static/media/confirmation-image.3db22b31.gif";